import { IRegularCore } from './cores/RegularCore';
import { IFireCore } from './cores/FireCore';
import { IEntity, IGameData, Place } from 'js/bubbleCore/types';
import { IEvent } from 'js/bubbleCore/events';
import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';

export interface IBubbleHandler<T extends BubbleType> {
  isMatching(bubble: Bubble<T>, otherBubble: Bubble): boolean;
  onShootedBubbleGridBubbleCollision(
    board: BubbleGameBoard,
    bubble: Bubble<T>,
    colliders: Bubble[],
  ): void;
}

export interface ICore {

}

export enum BubbleColor {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  NONE = 'NONE',
}

export enum BubbleType {
  Regular = 'Regular',
  Fire = 'Fire',
}

export interface IBubble extends IEntity {
  core: BubbleCore;
  radius: number;
  radiusInGrid: number;
  place: Place;
  col: number;
  row: number;
  hexSpaceX: number;
  hexSpaceY: number;
  velX: number;
  velY: number;
}


export interface BubbleTypeToCore {
  [BubbleType.Regular]: IRegularCore;
  [BubbleType.Fire]: IFireCore;
}

// export type BubbleCore = BubbleTypeToCore[keyof BubbleTypeToCore];
export type BubbleCore<T extends BubbleType = BubbleType> = BubbleTypeToCore[T];
export type Bubble<T extends BubbleType = BubbleType> = IBubble & { core: BubbleCore<T>};